"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
exports.__esModule = true;
exports.spectrumLogQueueAdapter = exports.SpectrumLogQueueAdapter = void 0;
var spectrumLogQueue_1 = require("./spectrumLogQueue");
var grapheneMetrics_1 = require("../../grapheneMetrics");
var loglevel_1 = require("loglevel");
var environment_1 = require("../../environment");
var debug_1 = require("../../debug");
var spectrumUtils_1 = require("../../util/spectrumUtils");
var S0_EVENTS_SET = new Set(["adTrackEvent", "adTrackEventShadow"]);
var log = (0, loglevel_1.getLogger)("spectrumLogQueueAdapter");
var SpectrumLogQueueAdapter = (function () {
    function SpectrumLogQueueAdapter() {
        this.spectrumLogQueuesMap = new Map();
        this.queueHasLatestHeaderSet = new Set();
    }
    SpectrumLogQueueAdapter.prototype.enqueueItemsToQueues = function (items, region) {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function () {
            var resolvedItems, resolvedItems_1, resolvedItems_1_1, item, priorityOfEvent, designatedQueue;
            var e_1, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        log.info("Enqueueing", items.length, "Spectrum items to queue(s)...");
                        return [4, Promise.all(items)];
                    case 1:
                        resolvedItems = _j.sent();
                        try {
                            for (resolvedItems_1 = __values(resolvedItems), resolvedItems_1_1 = resolvedItems_1.next(); !resolvedItems_1_1.done; resolvedItems_1_1 = resolvedItems_1.next()) {
                                item = resolvedItems_1_1.value;
                                if (item === null) {
                                    continue;
                                }
                                if ((0, spectrumUtils_1.isSpectrumHeader)(item)) {
                                    log.info("Enqueuing a new SpectrumHeader", item);
                                    (0, debug_1.logDebugAction)({ type: "SpectrumHeaderEnqueued", header: item });
                                    grapheneMetrics_1.blizzardGraphene.increment({
                                        metricsName: grapheneMetrics_1.STREAM_SPECTRUM_HEADER,
                                        dimensions: {
                                            app: (_a = (0, environment_1.getAppEnvironment)().application) !== null && _a !== void 0 ? _a : ""
                                        }
                                    });
                                    this.queueHasLatestHeaderSet.clear();
                                    this.lastHeader = item;
                                }
                                else if ((0, spectrumUtils_1.isSpectrumEvent)(item)) {
                                    log.debug("Enqueuing an event", item);
                                    (0, debug_1.logDebugAction)({ type: "SpectrumEventEnqueued", event: item });
                                    grapheneMetrics_1.blizzardGraphene.increment({
                                        metricsName: grapheneMetrics_1.STREAM_SPECTRUM_EVENT,
                                        dimensions: {
                                            name: (_c = (_b = item.event) === null || _b === void 0 ? void 0 : _b.$case) !== null && _c !== void 0 ? _c : "",
                                            app: (_d = (0, environment_1.getAppEnvironment)().application) !== null && _d !== void 0 ? _d : ""
                                        }
                                    });
                                    priorityOfEvent = S0_EVENTS_SET.has((_f = (_e = item.event) === null || _e === void 0 ? void 0 : _e.$case) !== null && _f !== void 0 ? _f : "") ? "s0" : "s1";
                                    if (!this.isLogQueueCreated(region, priorityOfEvent)) {
                                        this.createQueuesAndSetInMap(region, priorityOfEvent);
                                    }
                                    designatedQueue = (_g = this.spectrumLogQueuesMap.get(region)) === null || _g === void 0 ? void 0 : _g.get(priorityOfEvent);
                                    this.sendHeaderToQueueOrNot(designatedQueue, region, priorityOfEvent);
                                    designatedQueue === null || designatedQueue === void 0 ? void 0 : designatedQueue.append(item);
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (resolvedItems_1_1 && !resolvedItems_1_1.done && (_h = resolvedItems_1["return"])) _h.call(resolvedItems_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2];
                }
            });
        });
    };
    SpectrumLogQueueAdapter.prototype.createQueuesAndSetInMap = function (region, priority) {
        var _a;
        if (this.spectrumLogQueuesMap.has(region)) {
            (_a = this.spectrumLogQueuesMap.get(region)) === null || _a === void 0 ? void 0 : _a.set(priority, new spectrumLogQueue_1.SpectrumLogQueue(priority, region));
        }
        else {
            var priorityLogQueueMap = new Map([[priority, new spectrumLogQueue_1.SpectrumLogQueue(priority, region)]]);
            this.spectrumLogQueuesMap.set(region, priorityLogQueueMap);
        }
    };
    SpectrumLogQueueAdapter.prototype.isLogQueueCreated = function (region, priority) {
        var _a;
        return ((_a = this.spectrumLogQueuesMap.get(region)) === null || _a === void 0 ? void 0 : _a.get(priority)) !== undefined;
    };
    SpectrumLogQueueAdapter.prototype.sendHeaderToQueueOrNot = function (logQueue, region, priorityOfEvent) {
        var key = region.toString() + priorityOfEvent;
        if (!this.queueHasLatestHeaderSet.has(key)) {
            logQueue === null || logQueue === void 0 ? void 0 : logQueue.append(this.lastHeader);
            this.queueHasLatestHeaderSet.add(key);
            return true;
        }
        return false;
    };
    return SpectrumLogQueueAdapter;
}());
exports.SpectrumLogQueueAdapter = SpectrumLogQueueAdapter;
exports.spectrumLogQueueAdapter = new SpectrumLogQueueAdapter();
//# sourceMappingURL=spectrumLogQueueAdapter.js.map